module.exports = __webpack_public_path__ + "img/panama-city.825df903.jpg";